import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listQuestion } from 'states/modules/question'

function useTemplateVarsForm(templateId) {
	const dispatch = useDispatch()
	const { questions, loading, error } = useSelector(({ question }) => ({
		questions: question.data,
		loading: question.loading,
		error: question.error,
	}))

	useEffect(() => {
		if (templateId) {
			dispatch(
				listQuestion({
					modelId: templateId,
					documentTitle: 'Nova solicitação',
					parent: null,
				})
			)
		}
	}, [dispatch, templateId])

	return { questions, loading, error }
}

export default useTemplateVarsForm
